import instance from "../config";

// Usuarios del sistema (solo admin).
export const getUsuarios = async () => {
  const { data } = await instance.get("/usuarios");
  return data;
};

export const crearUsuario = async ({ username, password, correo, rol, dobleFactor }) => {
  const { data } = await instance.post("/usuarios", { username, password, correo, rol, dobleFactor });
  return data;
};

// username y password opcionales: si van vacíos no se cambian.
// estado y dobleFactor opcionales: si no se envían, el backend conserva el valor actual.
export const editarUsuario = async (id, { username, correo, rol, estado, password, dobleFactor }) => {
  const { data } = await instance.put(`/usuarios?id=${id}`, { username, correo, rol, estado, password, dobleFactor });
  return data;
};

// los electores, conteos y actas que registró quedan sin registrador (solo los ve el admin)
export const eliminarUsuario = async (id) => {
  const { data } = await instance.delete(`/usuarios?id=${id}`);
  return data;
};
